import { Components, Theme } from "@mui/material";

export const MuiDialogContent: Components<
  Omit<Theme, "components">
>["MuiDialogContent"] = {};
